import { Component, OnInit } from '@angular/core';
import { ReportingFilterOptionsService, REPORTING_FILTER_OPTIONS } from '../services/reporting-filter-options.service';

@Component({
  selector: 'app-reporting-page',
  templateUrl: './reporting-page.component.html',
  providers: [ 
    { provide: REPORTING_FILTER_OPTIONS, useClass: ReportingFilterOptionsService }
  ]
})
export class ReportingPageComponent implements OnInit {
  constructor() { 
  }

  ngOnInit() {
  }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/reporting/reporting-page/reporting-page.component.ts